<div class="container-fluid mt-3">

  <div class="row">
    <div [ngClass]="!morsecode || morsecode?.length < 0 ? 'col-sm-12' : 'col-sm-5' ">
      <div class="card mb-4">
        <h3 class="card-header">Text In English</h3>
        <div class="card-body">
          <mat-form-field class="mb-4" appearance="outline">
            <textarea rows="7" matInput [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"></textarea>
          </mat-form-field>
          <div class="float-right">
            <button type="button" class="btn" (click)="generateMorseCode()">Convert</button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="morsecode?.length > 0">
      <div class="col-sm-1" [ngStyle]="!isMobile() ? {'display': 'flex', 'align-items': 'center'} :
       {'display': 'flex', 'justify-content': 'center'}">
        <fa-icon [icon]="isMobile() ? arrowDownIcon : arrowRightIcon" size="4x"></fa-icon>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <h3 class="card-header">Morse Code</h3>
          <div class="card-body">
            <h2 #code class="card-text"><pre>{{morsecode}}</pre></h2>
          </div>
          <div class="card-body" *ngIf="!!morsecode">
            <button class="float-right ml-1 btn" (click)="playMorseText()">
              <fa-icon size="2x" [icon]="play" style="color: black !important;"></fa-icon>
            </button>
            <button class="float-right ml-1 btn" (click)="pauseResumeAudio()">
              <fa-icon size="2x" [icon]="pause" style="color: black !important;"></fa-icon>
            </button>
            <button class="float-right btn" (click)="stopAudio()">
              <fa-icon size="2x" [icon]="stop" style="color: black !important;"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row mt-5">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <app-reference [history]="storage"></app-reference>
        </div>
      </div>
    </div>
  </div>
</div>
